import { useAiCreateReportFeature, useShowAiDebug } from '../../utils/hooks';
import usePermission from '../../utils/hooks/permissionHooks';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';

const useShowLumosButton = (
  activeSchemaId: string,
  permissionKey: PermissionKey,
  // TODO temp param, to be removed once the CSE-only limit is lifted
  showToNonCse: boolean = false,
) => {
  // Lumos button show/hide logic
  const isAiCreateReportFeatureEnabled = useAiCreateReportFeature();
  const { checkIsPermitted } = usePermission();
  const isPermittedToCreateReport = checkIsPermitted({
    requiredPermissionKeys: [permissionKey],
    schemaId: activeSchemaId,
  });

  // TODO XXX the "AiDebug" feature limits the exposure of this to Support Engineer Admins.
  const isAiDebugFeatureEnabled = useShowAiDebug();
  const visibleToNonCse = showToNonCse || isAiDebugFeatureEnabled;

  return (
    visibleToNonCse &&
    isAiCreateReportFeatureEnabled &&
    isPermittedToCreateReport
  );
};

export default useShowLumosButton;
